import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import {
  GetOrderslistBookingManagementSlice,
  UpdateStatusManagementIntransitSlice,
} from "../../../../redux/features/BookingManagementSlice";
import { Loader } from "../../../../common/Loader/Loader";
import useParamsFormat from "../../../../common/Params Values format/ParamsFormat";
import Pagination from "../../../../common/pagination/PaginationCustom";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Share from "../../../../common/Share";
import { FaCopy, FaShareAlt } from "react-icons/fa";
import { WhatsappIcon, WhatsappShareButton } from "react-share";

const ConfirmedBooking = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });

  const [CopiedData, setCopiedData] = useState("");

  const { loading } = useSelector((state) => state.BookingManagement);

  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    dispatch(
      GetOrderslistBookingManagementSlice(createDataSetParams(getSearch))
    ).then((res) => {
      const dummyData = res?.payload?.data;
      setData(dummyData);
      setPagination(res.payload.pagination);
    });
  }, []);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetOrderslistBookingManagementSlice(dataSet)).then((res) => {
      const dummyData = res?.payload?.data;
      console.log(dummyData);
      setData(dummyData);
      setPagination(res.payload.pagination);
    });
  };

  const handleStatusUpdate = (id) => {
    const data = {
      id: id,
      data: {
        status: "in-transit",
      },
    };
    dispatch(UpdateStatusManagementIntransitSlice(data)).then((res) => {
      dispatch(
        GetOrderslistBookingManagementSlice(createDataSetParams(getSearch))
      ).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    });
  };

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      dispatch(
        GetOrderslistBookingManagementSlice(createDataSetParams(getSearch))
      ).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      dispatch(GetOrderslistBookingManagementSlice()).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  const handleCopy = (item, CopyTo) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'long' 
      });
    };

    const textToCopy = `Order Details:

Order ID: #${item.orderId}

Order Date: ${formatDate(item.createdAt || item.orderDate)}

Address: ${item?.deliveryAddress?.houseNo ? `${item.deliveryAddress.houseNo}, ` : ''}${item?.deliveryAddress?.street ? `${item.deliveryAddress.street}, ` : ''}${item?.deliveryAddress?.city ? `${item.deliveryAddress.city}, ` : ''}${item?.deliveryAddress?.state ? `${item.deliveryAddress.state}. ` : ''}${item?.deliveryAddress?.pincode ? `Pin ${item.deliveryAddress.pincode}` : ''}

${item?.deliveryAddress?.pincode || ''}
GoogleMapLocation: https://www.google.com/maps/search/?q=%20https%3A%2F%2Fmaps.app.goo.gl%2FuGU5FJRMF4dPPXqP9%3Fg_st%3Dac%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%0A

Arrival Time: ${item?.arrivalTime || item?.deliveryTime || '4:00 PM'}

Amount: ₹${item?.totalAmount || '0'}/-

Comments:
${item?.comments || item?.specialInstructions || 'No special comments'}

Add-On Items:
${item?.addOns ? item.addOns.map((addon, index) => `${index + 1}. ${addon.name} Quantity ${addon.quantity}: ₹${addon.price || '0'}`).join('\n') : 'No add-on items'}

Product Name: ${item?.productName || 'N/A'}
Image URL: ${item?.prodimages?.[0] || item?.productImage || 'No image available'}

Inclusion: 
${item?.inclusion || item?.productInclusion || 'No inclusion details available'}

Customer: ${item?.customerFullName}
Phone: ${item?.customerContactNumber}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        if (CopyTo !== "WhatsApp") toast.success("data copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <>
      <div>
        <div className="Small-Wrapper">
          <div className="Filter justify-content-between">
            <div className="Filter">
              <div className="form-group">
                <label>Search</label>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search"
                  name="search"
                  value={getSearch?.search}
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  value={getSearch?.fromDate}
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={getSearch?.toDate}
                  name="toDate"
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button
                  className="Button"
                  style={{ marginRight: "10px" }}
                  onClick={HandleSearch}
                >
                  Apply
                </button>

                <button className="Button Cancel" onClick={HandleReset}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
            <div className="FilterRight">
              <div className="form-group">
                <label>By Sort</label>
                <select className="form-control">
                  <option value="select">--Select--</option>
                  <option value="select">Today</option>
                  <option value="Month">This Week</option>
                  <option value="Month">This Month</option>
                  <option value="Year">This Year</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="TableList">
          <table style={{ width: "180%" }}>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Booking Id</th>
                <th>Booking Date &amp; Time</th>
                <th>Customer id</th>
                <th>Customer name</th>
                <th>Customer contact details</th>
                <th>Delivery address</th>
                {/* <th>Item quantity</th> */}
                <th>Amount (Rs. Symbol)</th>
                <th>Payment Mode</th>
                <th>Add Decorator partner details</th>
                {/* <th>Add supplier details</th> */}
                <th>View Booking details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <Loader />
              ) : Array.isArray(data) && data?.length > 0 ? (
                data?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                      <td>{item?.orderId}</td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>{item?.userId}</td>
                      <td>{item?.customerFullName}</td>
                      <td>{item?.customerContactNumber}</td>
                      <td style={{ width: 200 }}>
                        {item?.deliveryAddress?.street},
                        {item?.deliveryAddress?.pincode}
                      </td>
                      {/* <td>{item?.itemQuantity}</td> */}
                      <td>{item?.totalAmount}</td>
                      <td>{item?.paymentMode}</td>
                      <td>
                        <Link
                          state={item?.decoratorAddress}
                          to={`/OrderManagment/ConfirmedBooking/AddDecoratorPartnerDetails/${item?._id}`}
                        >
                          <span
                            className="Green"
                            data-toggle="modal"
                            data-target="#AddDecoratorPartnerModal"
                          >
                            Add
                          </span>
                        </Link>
                      </td>
                      {/* <td><span class="Green" data-toggle="modal" data-target="#AddSupplierModal">Add</span></td> */}
                      <td>
                        <div className="Actions">
                          <Link
                            className="Blue"
                            to={`/OrderManagment/OrderActiveConfirmDetails/${item?._id}`}
                          >
                            <i className="fa fa-eye" />
                          </Link>
                        </div>
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <Link
                            to={`/OrderManagment/ConfirmedBooking/CancelOrder/${item?._id}`}
                            href="javascript:void(0);"
                            className="RedCancel"
                            data-toggle="modal"
                            data-target="#CancelOrder"
                            style={{ margin: "3px" }}
                          >
                            Cancel
                          </Link>
                          <button
                            className="btn btn-primary"
                            onClick={() => handleStatusUpdate(item?._id)}
                          >
                            In-Transit
                          </button>
                          <div onClick={() => handleCopy(item, "WhatsApp")}>
                            <WhatsappShareButton
                              url={`Order Details:

Order ID: #${item.orderId}

Order Date: ${new Date(item.createdAt || item.orderDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }) || 'N/A'}

Address: ${item?.deliveryAddress?.houseNo ? `${item.deliveryAddress.houseNo}, ` : ''}${item?.deliveryAddress?.street ? `${item.deliveryAddress.street}, ` : ''}${item?.deliveryAddress?.city ? `${item.deliveryAddress.city}, ` : ''}${item?.deliveryAddress?.state ? `${item.deliveryAddress.state}. ` : ''}${item?.deliveryAddress?.pincode ? `Pin ${item.deliveryAddress.pincode}` : ''}

${item?.deliveryAddress?.pincode || ''}
GoogleMapLocation: https://www.google.com/maps/search/?q=%20https%3A%2F%2Fmaps.app.goo.gl%2FuGU5FJRMF4dPPXqP9%3Fg_st%3Dac%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%0A

Arrival Time: ${item?.arrivalTime || item?.deliveryTime || '4:00 PM'}

Amount: ₹${item?.totalAmount || '0'}/-

Product Name: ${item?.productName || 'N/A'}

Customer: ${item?.customerFullName}
Phone: ${item?.customerContactNumber}

Product Image: ${item?.prodimages?.[0] || item?.productImage || 'No image available'}`}
                              media={item?.prodimages?.[0] || item?.productImage}
                            >
                              <WhatsappIcon size={40} round={true} />
                            </WhatsappShareButton>
                          </div>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => handleCopy(item)}
                          >
                            <FaCopy style={{ fontSize: "27px" }} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={13}>There is no data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          arr={arr}
          page={page}
          handlePagesIncrease={handlePagesIncrease}
          FetchDataOnPages={FetchDataOnPages}
          handlePagesDecrease={handlePagesDecrease}
        />
      </div>
      <Outlet />
    </>
  );
};

export default ConfirmedBooking;

const ShareModal = ({ url, show, handleClose }) => {
  return (
    <div className="p-4" style={{ width: "200px" }}>
      {/* Bootstrap Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-modal" // Custom class for styling
      >
        <Modal.Body className="p-2" style={{ height: "55px" }}>
          <div className="d-flex">
            <Share url={url} />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
